import script from "./GlobusHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusHeader.vue?vue&type=script&setup=true&lang=js"

import "./GlobusHeader.vue?vue&type=style&index=0&id=fe65a7ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe65a7ba"]])

export default __exports__